import React from 'react';
import { FormattedMessage } from 'react-intl';


/**
 * Return either "Sponsored", "Featured" or null based on the given arguments.
 *
 * @param {boolean} isSponsored
 * @param {boolean} isMonetized
 * @return {React.JSX.Element|null}
 */
function getDesignationMessage({ isSponsored, isMonetized }) {
    // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
    return isSponsored
        ? (
            <FormattedMessage
                id="base-ui.product-designation.sponsored"
                defaultMessage="Sponsored"
            />
        )
        // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
        : isMonetized
            ? (
                <FormattedMessage
                    id="base-ui.product-designation.featured"
                    defaultMessage="Featured"
                />
            )
            : null;
}

export default getDesignationMessage;
